export const SET_TRACKER_PREFERENCES_LIST = 'SET_TRACKER_PREFERENCES_LIST';

export default {
    SET_TRACKER_PREFERENCES_LIST
}